export type Theme = "light" | "dark";

const storageKey = "kitae-transfer-theme";

function systemTheme(): Theme {
  return globalThis.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function resolveInitialTheme(preference: Theme | undefined, prefersDark: boolean): Theme {
  return preference ?? (prefersDark ? "dark" : "light");
}

export function readThemePreference(storage?: Pick<Storage, "getItem">): Theme | undefined {
  try {
    const value = (storage ?? globalThis.localStorage)?.getItem(storageKey);
    return value === "light" || value === "dark" ? value : undefined;
  } catch {
    return undefined;
  }
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
}

export function initializeTheme(): Theme {
  const theme = resolveInitialTheme(readThemePreference(), systemTheme() === "dark");
  applyTheme(theme);
  return theme;
}

export function saveTheme(theme: Theme, storage?: Pick<Storage, "setItem">): void {
  try {
    (storage ?? globalThis.localStorage)?.setItem(storageKey, theme);
  } catch {
    // A private browsing policy may reject localStorage; the active page still keeps its theme.
  }
  applyTheme(theme);
}
